import { isSIREN } from 'vat-siren-siret';

export function isValidSiren(value?: string): boolean {
  return value ? isSIREN(value) : true;
}
